"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDotnetAppFileContentAction = void 0;
const stream_utils_1 = require("../../stream-utils");
/**
 * Matches *.deps.json files produced by `dotnet publish`.
 * Excludes framework deps.json files under the shared runtime directory
 * (e.g. /usr/share/dotnet/shared/Microsoft.NETCore.App/8.0.0/).
 */
function filePathMatches(filePath) {
    if (!filePath.endsWith(".deps.json") ||
        filePath.includes("/dotnet/shared/") ||
        filePath.includes("/dotnet/packs/")) {
        return false;
    }
    return true;
}
exports.getDotnetAppFileContentAction = {
    actionName: "dotnet-app-files",
    filePathMatches,
    callback: stream_utils_1.streamToString,
};
//# sourceMappingURL=static.js.map